import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=0d3fb1d8&scoped=true"
import script from "./Home1.vue?vue&type=script&lang=js"
export * from "./Home1.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Home1.vue?vue&type=style&index=0&id=0d3fb1d8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0d3fb1d8",
  "497a1a51"
  
)

export default component.exports